export const paletteColors: {
  [key: string]: string[];
} = {
  'Verdant Shade': ['#9ca89c', '#5f7361', '#333f33', '#151915'],
  'Sandy Beach': ['#fcf2d7', '#e2cc9f', '#7f6641', '#352813'],
  'Forest Whispers': ['#cad2c5', '#84a98c', '#42705f', '#243738'],
  'Earth Whisper': ['#ddd3ca', '#c0a88b', '#595347', '#242f29'],
  'Autumn Dusk': ['#ebd4cb', '#da9f93', '#8e0d29', '#4f0614'],
  'Azure Depths': ['#cae0ef', '#a3cef1', '#6096ba', '#274c77'],
  'Lunar Rock': ['#ffffff', '#d9d9d9', '#696969', '#282828'],
};

export const palette = `
--Verdant-Shade-0: ${paletteColors['Verdant Shade'][0]};
--Verdant-Shade-1: ${paletteColors['Verdant Shade'][1]};
--Verdant-Shade-2: ${paletteColors['Verdant Shade'][2]};
--Verdant-Shade-3: ${paletteColors['Verdant Shade'][3]};

--Sandy-Beach-0: ${paletteColors['Sandy Beach'][0]};
--Sandy-Beach-1: ${paletteColors['Sandy Beach'][1]};
--Sandy-Beach-2: ${paletteColors['Sandy Beach'][2]};
--Sandy-Beach-3: ${paletteColors['Sandy Beach'][3]};

--Forest-Whispers-0: ${paletteColors['Forest Whispers'][0]};
--Forest-Whispers-1: ${paletteColors['Forest Whispers'][1]};
--Forest-Whispers-2: ${paletteColors['Forest Whispers'][2]};
--Forest-Whispers-3: ${paletteColors['Forest Whispers'][3]};

--Earth-Whisper-0: ${paletteColors['Earth Whisper'][0]};
--Earth-Whisper-1: ${paletteColors['Earth Whisper'][1]};
--Earth-Whisper-2: ${paletteColors['Earth Whisper'][2]};
--Earth-Whisper-3: ${paletteColors['Earth Whisper'][3]};

--Autumn-Dusk-0: ${paletteColors['Autumn Dusk'][0]};
--Autumn-Dusk-1: ${paletteColors['Autumn Dusk'][1]};
--Autumn-Dusk-2: ${paletteColors['Autumn Dusk'][2]};
--Autumn-Dusk-3: ${paletteColors['Autumn Dusk'][3]};

--Azure-Depths-0: ${paletteColors['Azure Depths'][0]};
--Azure-Depths-1: ${paletteColors['Azure Depths'][1]};
--Azure-Depths-2: ${paletteColors['Azure Depths'][2]};
--Azure-Depths-3: ${paletteColors['Azure Depths'][3]};

--Lunar-Rock-0: ${paletteColors['Lunar Rock'][0]};
--Lunar-Rock-1: ${paletteColors['Lunar Rock'][1]};
--Lunar-Rock-2: ${paletteColors['Lunar Rock'][2]};
--Lunar-Rock-3: ${paletteColors['Lunar Rock'][3]};

--Default-0: transparent;
--Default-1: #000000;
`;
